module.exports = __webpack_public_path__ + "files/1cf3817fc76fd10bb7575fb24b735bfc.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/roboto-italic-webfont.woff
 ** module id = 1006
 ** module chunks = 0
 **/